import {
  usePlayersStore,
  useRochamboStore,
  useSessionStore,
} from "@/stores";
import type {
  RochamboPick,
} from "@/types";

const PICKS = new Set(["rock", "paper", "scissors"]);

/** A duelist secretly sends their pick to the storyteller */
export function handleRochamboPick(params: unknown) {
  const session = useSessionStore();
  if (session.isPlayerOrSpectator) return;
  if (!Array.isArray(params)) return;

  const [seat, pick, playerId] = params as [unknown, unknown, unknown];
  if (typeof seat !== "number") return;
  if (typeof pick !== "string" || !PICKS.has(pick)) return;

  // Only the player sitting on that seat may pick for it
  const player = usePlayersStore().players[seat];
  if (!player || !player.id || player.id !== playerId) return;

  useRochamboStore().receivePick([seat, pick as RochamboPick]);
}
